import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { sessionQueries } from '@/api';
import { LoginPage } from '@/features/operator/login-page';

const loginSearchSchema = z.object({
	/** Ставить guard, коли ввійшов не оператор. */
	error: z.enum(['operator']).optional(),
});

export const Route = createFileRoute('/login')({
	validateSearch: loginSearchSchema,
	beforeLoad: async ({ context, search }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueries.current());
		if (session?.user.role === 'OPERATOR' && !search.error) throw redirect({ to: '/bids' });
	},
	component: LoginPage,
});
